export default __webpack_public_path__ + "static/media/lauren_james.90df6933.png";